
import { useState } from 'react';
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Scripture } from "../prayer/types";

export interface PrayerResult {
  prayer: string;
  scriptures: Scripture[];
}

export const usePrayerGeneration = () => {
  const [prayerRequest, setPrayerRequest] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [prayerResult, setPrayerResult] = useState<PrayerResult | null>(null);
  const { toast } = useToast();

  // Function to generate prayer
  const generatePrayer = async () => {
    if (!prayerRequest.trim()) {
      toast({
        title: "Prayer request needed",
        description: "Please enter what you want to pray about.",
        variant: "destructive"
      });
      return;
    }

    setLoading(true);
    setPrayerResult(null);

    try {
      const { data, error } = await supabase.functions.invoke('generate-prayer', {
        body: { prayerRequest }
      });

      if (error) throw new Error(error.message);
      
      setPrayerResult(data);
    } catch (error) {
      console.error('Error generating prayer:', error);
      toast({
        title: "Failed to generate prayer",
        description: error instanceof Error ? error.message : "An unexpected error occurred",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    prayerRequest,
    setPrayerRequest,
    loading,
    prayerResult,
    generatePrayer
  };
};
